import { render, staticRenderFns } from "./BackgroundGrid.vue?vue&type=template&id=66f0662c&"
import script from "./BackgroundGrid.vue?vue&type=script&lang=js&"
export * from "./BackgroundGrid.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports